
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drawings",
      function () {
        return require("private-next-pages/drawings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drawings"])
      });
    }
  